import type { Theme } from '@mui/material';

import { muiSelectStyles } from 'src/theme/sharedStyles';

export const styles = {
  stack: (theme: Theme) => ({
    gap: '12px',
    flexDirection: 'column',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      height: '36px',
    },
  }),

  select: muiSelectStyles.filterSelect,

  menuProps: muiSelectStyles.filterPaper,

  menuItem: muiSelectStyles.filterMenuItem,

  textField: (theme: Theme) => ({
    flex: 2,
    color: theme.colors.neutral[500],
    backgroundColor: theme.colors.neutral[100],
  }),
};
